module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/59c79fa681b1421547664294a259b2d8.svg";